import type { PinType } from './analytics';

export type ReportCategory =
  | 'inaccurate_location'
  | 'wrong_info'
  | 'duplicate'
  | 'not_parking'
  | 'spam'
  | 'other';

export type ReportablePinType = Exclude<PinType, 'seeker'>;

export const REPORT_CATEGORIES: { value: ReportCategory; label: string }[] = [
  { value: 'inaccurate_location', label: 'Pin is in the wrong place' },
  { value: 'wrong_info', label: 'Price or details are wrong' },
  { value: 'duplicate', label: 'Duplicate of another pin' },
  { value: 'not_parking', label: 'Not a parking spot at all' },
  { value: 'spam', label: 'Spam or fake listing' },
  { value: 'other', label: 'Other' },
];

export function pinTypeToApiType(t: ReportablePinType): 'parking_spot' | 'rent_pin' {
  return t === 'spot' ? 'parking_spot' : 'rent_pin';
}

export function attachReportClickHandler(root: ParentNode = document): void {
  root.addEventListener('click', (e: Event) => {
    const btn = (e.target as HTMLElement | null)?.closest<HTMLElement>('button[data-report]');
    if (!btn) return;
    const pinType = btn.getAttribute('data-pin-type') as ReportablePinType | null;
    const pinId = btn.getAttribute('data-pin-id');
    if (!pinType || !pinId) return;
    if (pinType !== 'spot' && pinType !== 'rent') return;
    window.dispatchEvent(
      new CustomEvent('parksy:open-report', { detail: { pinType, pinId } })
    );
  });
}
